module.exports = __webpack_public_path__ + "static/img/advantage4.62757242.png";